export const formatDollars = (usd: number): string => `$${usd.toFixed(2)}`

export const formatCents = (cents: number): string => formatDollars(cents / 100)

// Money is integer cents, so a typed price is read digit by digit: multiplying the parsed float by
// 100 turns 1.15 into 114.999…, which is a cent short once truncated. Returns null for anything that
// is not a plain dollar amount.
export function dollarsToCents(input: string): number | null {
  const match = /^\$?(\d+)(?:\.(\d{1,2}))?$/.exec(input.trim())
  if (!match) return null
  const [, dollars, cents = ''] = match
  return Number(dollars) * 100 + Number(cents.padEnd(2, '0'))
}

// The plain form a price input holds, without the dollar sign formatCents adds.
export const centsToDollars = (cents: number): string => (cents / 100).toFixed(2)
